import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { IssuerAPIService } from '../services/issuer-api.service';
import { Router } from '@angular/router';
declare function responsiveVoiceSpeak(title, innerText): any;
declare const HomePageLoad: any;
declare function HomevoiceOnKeyPress(value, key): any;
declare function BrowseObligorsponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function voiceForLastObligor(targetid): any;
declare var $: any;
declare const WebCastPageLoad: any;
declare function WebCastresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function WebcastOpneModelMessage(eventId, innerText): any;
declare function HomeresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function FontSizeSettings(): any;
@Component({
  selector: 'app-continuingeducation',
  templateUrl: './continuingeducation.component.html',
  styleUrls: ['./continuingeducation.component.css']
})
export class ContinuingeducationComponent implements OnInit {
  public obligorId: string;
  public onDemandWebinalist: any = null;
  public onUpComingWebinarlist: any = null;
  public commonTabIndex = 0;
  currentrow = null;
  public lastColumn: number = 0;
  constructor(private IssuerAPI: IssuerAPIService, public router: Router) { }
  onkeyPress(event: any): void {
    if (event.keyCode == 27) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }
   }
  onKeyUp(event: any, webinarPlayLink) {
    debugger;

    if (event.target.id == "btnclose" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Close button. Use enter to close the webinar.");
      return;
    }

    if (event.target.id == "webcastVideo" && event.keyCode == 27) {
      $('#btnWebcastClose').focus();
      WebcastOpneModelMessage("btnWebcastClose", "");
      return;
    }
    if (event.keyCode == 13 || event.keyCode == 9) {
      if (event.keyCode == 13) {
       //if (modelpopupStatus == 0) {
          if (event.target.id == "tdwebinarPlayLink") {
            this.showModal(event, webinarPlayLink);
            return;
          }
          else if (event.target.id == "btnclose")  {
            this.closeVideo(event);
            return;
          }
          
      }
      
    }
    $("#hdRows_Education").val(0);
    if (webinarPlayLink != undefined) {
      if (event.target.id == "PlayID" && event.keyCode == 13) {
        $("#PlayID").click();
        return;
      }

      if (event.target.id == "tdwebinarPlayLink" && event.keyCode == 13) {
        responsiveVoiceSpeak("", "Webinar is now playing. You can use spacebar to play and pause the video or use tab to go to the close button.");    
        $("#PlayID").click();
        return;
      }
    }
    //if (event.target.id == "tdtitle" && event.keyCode == 27) {
    //  document.getElementById("SkipMainContentfooter").focus();
    //  BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);

    //  return;
    //}

    if ((event.target.id == "tdtitle" || event.target.id == "tdWebinarLink" || event.target.id == "tdisComplete" || event.target.id == "tdcompletionDate" || event.target.id == "tddurationMinutes" || event.target.id == "tdtitle" || event.target.id == "tdWebinarDate" || event.target.id == "tdDemandDesc" || event.target.id == "tdWebinarLink") && (event.keyCode == 16)) {
      document.getElementById("onDemandWeb").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("onDemandWeb").innerText, "onDemandWeb", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);

      return;
    }

    if ((event.target.id == "tdtitle" || event.target.id == "tdWebinarLink" || event.target.id == "tdisComplete" || event.target.id == "tdcompletionDate" || event.target.id == "tddurationMinutes" || event.target.id == "tdtitle" || event.target.id == "tdWebinarDate" || event.target.id == "tdDemandDesc" || event.target.id == "tdWebinarLink") && (event.keyCode == 9)) {
      if (event.shiftKey) {
        document.getElementById("onDemandWeb").focus();
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("onDemandWeb").innerText, "onDemandWeb", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
      return;
    }

    // add shift + tab functionality to set tab 
    if ((event.target.id == "tdUPtitle" || event.target.id == "tdUPWebinarDate" || event.target.id == "tdUPDemandDesc" || event.target.id == "tdUPWebinarLink" || event.target.id == "tdUPCredits" || event.target.id == "tdUPfieldOfStudy") && (event.keyCode == 16)) {
      document.getElementById("upComingWeb").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("upComingWeb").innerText, "upComingWeb", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }
    if ((event.target.id == "tdUPtitle" || event.target.id == "tdUPWebinarDate" || event.target.id == "tdUPDemandDesc" || event.target.id == "tdUPWebinarLink" || event.target.id == "tdUPCredits" || event.target.id == "tdUPfieldOfStudy")  && (event.shiftKey && event.keyCode == 9)) {
      document.getElementById("upComingWeb").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("upComingWeb").innerText, "upComingWeb", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
    }
    if (event.keyCode == 27) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);

      return;
    }
    if (event.target.id == "lblContinuing" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblContinuing").innerText, "lblContinuing", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }
    if (event.target.id == "logoEducation" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("logoEducation").innerText, "logoEducation", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      // document.getElementById("upComingWeb").focus();
      return;
    }
    if (event.target.id == "servicemsg" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("servicemsg").innerText, "servicemsg", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      // document.getElementById("upComingWeb").focus();
      return;
    }
    if (event.target.id == "lblContinuing" && event.keyCode == 13) {
      document.getElementById("lblContinuing").click();
      return;
    }
    if (event.target.id == "servicemsg" && event.keyCode == 13) {
      document.getElementById("servicemsg").click();
      return;
    }
    //if (event.target.id == "tdUPtitle" && event.keyCode == 9) {
    //  BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("tdUPtitle").innerText, "tdUPtitle", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
    //  return;
    //}
    if (event.target.id == "upComingWeb" && event.keyCode == 13) {

      var innertext = document.getElementById("tdUPtitle").innerText;
      if (innertext == "No data available!") {
        // check no data in table
        document.getElementById("tdUPtitle").focus();
        responsiveVoiceSpeak("", innertext + ". Use escape key to exit the table and go to footer.");
      }
      else {

        document.getElementById("tdUPtitle").focus();
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("tdUPtitle").innerText, "tdUPtitle", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
      return;
    }
    if (event.target.id == "upComingWeb" && event.keyCode == 9) {
      if (this.onUpComingWebinarlist == undefined || this.onUpComingWebinarlist == null) {
        $("#hdRows_Education").val(0);
      }
      else {
        $("#hdRows_Education").val(this.onUpComingWebinarlist.length);
      }
      document.getElementById("upComingWeb").click();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("upComingWeb").innerText, "upComingWeb", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
    
      return;
    }
    if (event.target.id == "onDemandWeb" && event.keyCode == 9) {

      if (this.onDemandWebinalist == undefined || this.onDemandWebinalist == null) {
        $("#hdRows_Education").val(0);
      }
      else {
        $("#hdRows_Education").val(this.onDemandWebinalist.length);
      }
      document.getElementById("onDemandWeb").click();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("onDemandWeb").innerText, "onDemandWeb", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
     
      return;
    }
    if (event.target.id == "onDemandWeb" && event.keyCode == 13) {

      var innertext = document.getElementById("tdtitle").innerText;
      // check no data in table
      if (innertext == "No data available!") {
        document.getElementById("tdtitle").focus();
        responsiveVoiceSpeak("", innertext + ". Use escape key to exit the table and go to footer.");
      }
      else {
        document.getElementById("tdtitle").focus();
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("tdtitle").innerText, "tdtitle", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }

      return;
    }
    if (event.keyCode != 17) {
      debugger;
      var child_cell = $(event.target).index();
      if (event.keyCode == 40) {
        if ($(event.target).parent().next().children("td").eq(3).find("div").find("p").find("a").length > 0) {
          $("#hdwebinarPlayStatus").val(0);
        }
        else {
          $("#hdwebinarPlayStatus").val(1);
        }
        this.DownArrowKey(event, child_cell);
      }
      if (event.keyCode == 39) {
        this.RightArrowKey(event, child_cell);
      }
      if (event.keyCode == 38) {
        this.UpArrowKey(event, child_cell);
      }
      if (event.keyCode == 37) {
        this.LeftArrowKey(event, child_cell);
      }

    }
  }
  RightArrowKey(event, child_cell) {
    debugger;
    if (event.target.id == "tdtitle") {
      var target = $(event.target).next();
      $(target).trigger('focus');


      if (target[0].id == "tdWebinarDate") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
                
      }
    }
    if (event.target.id == "tdWebinarDate") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdDemandDesc") {
        
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdDemandDesc") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdwebinarPlayLink") {
        if ($(event.target).next().find("div").find("p").find("a").length > 0) {
          $("#hdwebinarPlayStatus").val(0);
        }
        else {
          $("#hdwebinarPlayStatus").val(1);
        }
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdwebinarPlayLink") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdWebinarLink") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdWebinarLink") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tddurationMinutes") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tddurationMinutes") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdcompletionDate") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdcompletionDate") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdisComplete") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdisComplete") {
      var obligorDescIndex = 0;
      $(event.target).parent().next().children("td").eq(0).focus();
      if (event.target.id == "tdisComplete") {
        if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;

          if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
            $('#hdlastRow').val('1');
          }
          else {
            $('#hdlastRow').val('0');
          }

          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, "tdtitle", event.target.type, "", event.target.htmlFor, event.target.alt, event.key)
        }
      }
    }

    //upcomming webinar
    if (event.target.id == "tdUPtitle") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdUPWebinarDate") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdUPWebinarDate") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdUPDemandDesc") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdUPDemandDesc") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdUPWebinarLink") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdUPWebinarLink") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdUPCredits") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdUPCredits") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdUPfieldOfStudy") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdUPfieldOfStudy") {
      var obligorDescIndex = 0;
      $(event.target).parent().next().children("td").eq(0).focus();
      if (event.target.id == "tdUPfieldOfStudy") {
        if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;

          if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
            $('#hdlastRow').val('1');
          }
          else {
            $('#hdlastRow').val('0');
          }

          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, "tdUPtitle", event.target.type, "", event.target.htmlFor, event.target.alt, event.key)
        }
      }
    }
  }
  LeftArrowKey(event, child_cell) {
    if (event.target.id == "tdisComplete") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdcompletionDate") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdcompletionDate") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tddurationMinutes") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tddurationMinutes") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdWebinarLink") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdWebinarLink") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdwebinarPlayLink") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdwebinarPlayLink") {
     
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdDemandDesc") {
        if ($(target).children("td").eq(child_cell).find("div").find("p").find("a").length > 0) {
          $("#hdwebinarPlayStatus").val(0);
        }
        else {
          $("#hdwebinarPlayStatus").val(1);
        }


        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }

    if (event.target.id == "tdDemandDesc") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdWebinarDate") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdWebinarDate") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdtitle") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdtitle") {
      var obligorDescIndex = 3;
      $(event.target).parent().prev().children("td").eq(7).focus();
      if (event.target.id == "tdtitle") {
        if (typeof $(event.target).parent().prev().children("td").eq(child_cell).prevObject[7] == "object") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[7].innerText;
          var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[7].title;
          $('#hdlastRow').val('0');
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, "tdisComplete", event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
        }
      }
    }

    // upcoming webinar
    if (event.target.id == "tdUPfieldOfStudy") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdUPCredits") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdUPCredits") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdUPWebinarLink") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdUPWebinarLink") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdUPDemandDesc") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdUPDemandDesc") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdUPWebinarDate") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdUPWebinarDate") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdUPtitle") {
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdUPtitle") {
      debugger;
      var obligorDescIndex = 3;
      $(event.target).parent().prev().children("td").eq(5).focus();
      if (event.target.id == "tdUPtitle") {
        if (typeof $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5] == "object") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5].innerText;
          var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5].title;
          $('#hdlastRow').val('0');
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, "tdUPfieldOfStudy", event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
        }
      }
    }

  }
  UpArrowKey(event, child_cell) {
    debugger;
    var innerText;
    var title;
    $(event.target).parent().prev().children("td").eq(child_cell).focus();
    if (event.target.id == "tdtitle") {
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdWebinarDate") {
       innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
       title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].title;
       BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdDemandDesc") {
       innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].innerText;
       title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].title;
       BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdwebinarPlayLink") {

      if ($(event.target).parent().prev().children("td").eq(child_cell).find("div").find("p").find("a").length > 0) {
        $("#hdwebinarPlayStatus").val(0);
      }
      else {
        $("#hdwebinarPlayStatus").val(1);
      }

      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdWebinarLink") {
    
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].innerText;
       title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].title;
       BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tddurationMinutes") {
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdcompletionDate") {
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[6].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[6].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdisComplete") {

      if ($(event.target).parent().prev().children("td").eq(child_cell).length == 0) {
        $('#hdlastRow').val('1');
      }
      else {
        $('#hdlastRow').val('0');
      }

      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[7].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[7].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }

      // Upcomming webinar 
    if (event.target.id == "tdUPtitle") {
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdUPWebinarDate") {
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdUPDemandDesc") {
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdUPWebinarLink") {
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdUPCredits") {
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdUPfieldOfStudy") {

      if ($(event.target).parent().prev().children("td").eq(child_cell).length == 0) {
        $('#hdlastRow').val('1');
      }
      else {
        $('#hdlastRow').val('0');
      }

      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }

  }
  DownArrowKey(event, child_cell) {
    debugger;
    var innerText;
    var title;
    $(event.target).parent().next().children("td").eq(child_cell).focus();
    if (event.target.id == "tdtitle") {
     if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

      if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
       }

       innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
       title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;
      
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdDemandDesc") {
      debugger;
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].title;

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)

      }
    }

    if (event.target.id == "tdwebinarPlayLink") {
      debugger;
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].title;

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)

      }
    }

    if (event.target.id == "tdWebinarDate") {
      debugger;
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

      innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
      title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].title;

       BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }

    }
    if (event.target.id == "tdWebinarLink") {
      debugger;

      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

      innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[4].innerText;
      title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[4].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
      
    }
    if (event.target.id == "tddurationMinutes") {
      debugger;
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
      innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[5].innerText;
      title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[5].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdcompletionDate") {
      debugger;
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
      innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[6].innerText;
      title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[6].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdisComplete") {
      debugger;
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
      innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[7].innerText;
      title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[7].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
    }


    // upcomming webinar

    if (event.target.id == "tdUPtitle") {
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdUPWebinarDate") {
      debugger;
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].title;

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
        
      }
    }
    if (event.target.id == "tdUPDemandDesc") {
      debugger;
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {
        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].title;
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
     }
    if (event.target.id == "tdUPWebinarLink") {
      debugger;
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {
        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].title;

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdUPCredits") {
      debugger;
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {
        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[4].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[4].title;
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdUPfieldOfStudy") {
      debugger;
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {
        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[5].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[5].title;
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
  }
  // To Get data from api
  GetonDemandWebList() {
     if (localStorage.getItem("OBLIGOR_ID")) {
      this.obligorId = localStorage.getItem("OBLIGOR_ID"); 
    }
    else {
      this.obligorId = "0";
     }

   document.getElementById("overlay").style.display = "block";
    this.IssuerAPI.GetIssuerupcomingWebinars(this.obligorId).subscribe(data => {
      debugger;
      this.onUpComingWebinarlist = data;
      return this.onUpComingWebinarlist;
    });


    
    this.IssuerAPI.GetIssuerOnDemandWebinars(this.obligorId).subscribe(data => {
      debugger;
      document.getElementById("overlay").style.display = "none";
      this.onDemandWebinalist = data;
      return this.onDemandWebinalist;
    });
    
  }
  setFontSizeSettings() {
     FontSizeSettings();
  }
  MagnifieronDynamicChecking() {
    FontSizeSettings();
  }
  ngOnInit() {
    document.getElementById("pageloadid").focus();
    
    this.GetonDemandWebList();
    //=========Caption Hide Show=============//
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }
    //============Voice Annotation On/Off=========
    if ($('#hidVoiceOnOff').val() == "OFF") {
      $('#btnVoiceAnnotation').val('OFF');
      $('#hidVoiceOnOff').val('OFF');
      //$('#btnPlayPause').attr('src', ('assets/images/pause.png'));
      $('#btnPlayPause').css('display', 'none');
    }
    else {
      $('#btnVoiceAnnotation').val('ON');
      $('#hidVoiceOnOff').val('ON');
      //$('#btnPlayPause').attr('src', ('assets/images/play-button.png'));
      $('#btnPlayPause').css('display', 'block');
    }
    this.MagnifieronDynamicChecking();
    responsiveVoiceSpeak("", "This is Continug Education page. Use tab to go to the next field.");    
  }
  OnVideoPay($event: any, url) {
     debugger;
   WebCastPageLoad();
    
    $('#myModalvideo').on('shown.bs.modal', function () {
      debugger;
      $('#divwebcastVideo').focus();
      WebcastOpneModelMessage("PlayWebcast", "");
     });
    responsiveVoiceSpeak("", "Webinar is now playing. You can use spacebar to play and pause the video or use tab to go to the close button.");    
    $('#divwebcastVideo').focus();
  }

  // close video popup
  closeVideo(event:any) {
    debugger;
    document.getElementById('webinarDiv').style.display = "none";
    //$('#webcastVideo').trigger('pause');
    var vid = <HTMLVideoElement>document.getElementById("webinarVideo");
    vid.pause();
    var rowsindex = $("#hdRowsIndex").val();
    responsiveVoiceSpeak("", "Column Video. Use enter key to play the webinar. ");
    $('#tblOnDemand tr:gt(0)').eq(rowsindex).find('td').eq(3).focus();
    return;
  }

  // show video pop up
  showModal(event, documentLink) {
    debugger;
    if (documentLink != undefined) {
      document.getElementById('webinarDiv').style.display = "block";
      $("#hdRowsIndex").val($(event.target).parents("tr").index());
      $('#divwebcastVideo').focus();
      $("#webinarVideo").attr("src", documentLink);
      responsiveVoiceSpeak("", "Webinar is now playing.You can use spacebar to play and pause the video or use tab to go to the close button.");
    }
  }

  // to play video popup
  onKeyUpPlayPause(event: any) {
    debugger;
    var vid = <HTMLVideoElement>document.getElementById("webinarVideo");
    if (vid.paused == true) {
      vid.play();
    }
    else {
      vid.pause();
    }
    $('#divwebcastVideo').focus();
    return;
  }
}
